import { useEffect, useState } from "react";
import { db } from "@healthdesk/shared-services";
import {
  MAP_CAROUSEL_COLLECTION,
  MAP_CAROUSEL_STATS_DOC_ID,
} from "../services/mapCarousel";

/**
 * Live stats for Carousel Global Ads admin (`publicConfig/mapCarouselStats`).
 * Document is publicly readable; writes remain server-side only.
 */
const useMapCarouselStats = () => {
  const [statsBySlideId, setStatsBySlideId] = useState({});
  const [statsError, setStatsError] = useState(null);

  useEffect(() => {
    const ref = db
      .collection(MAP_CAROUSEL_COLLECTION)
      .doc(MAP_CAROUSEL_STATS_DOC_ID);
    const unsub = ref.onSnapshot(
      (snap) => {
        setStatsError(null);
        if (!snap.exists) {
          setStatsBySlideId({});
          return;
        }
        const raw = snap.data()?.bySlideId;
        setStatsBySlideId(raw && typeof raw === "object" ? raw : {});
      },
      (err) => {
        console.warn("useMapCarouselStats: snapshot failed", err);
        setStatsError(err);
        setStatsBySlideId({});
      }
    );
    return () => unsub();
  }, []);

  return { statsBySlideId, statsError };
};

export default useMapCarouselStats;
